<ng-container *transloco="let t;">

  <p-card>
    <app-reporting-table
      [type]="'rolestatistics'"
    ></app-reporting-table>
  </p-card>

</ng-container>
